import * as React from 'react';
import LoginVM from '@src/pages/login/vm';
import VMComponent from '@src/components/vm-component';
import com from '@src/utils/com';
const styles = require('./index.less');

@com({ getInitialProps: LoginVM.getInitialProps })
export default class Login extends VMComponent(LoginVM) {
  render() {
    const vm = this.vm;
    const { entry, viewState, computes } = vm;
    const { account, password } = viewState;
    const { onSubmit, onValueChange } = entry;
    return (
      <div className={styles.root}>
        <table className={styles.table} align={'center'}>
          <tbody>
            <tr>
              <td className={styles.tableLable}>
                账号:<br />
                {/*<span className={styles.spanColor}>(2-16位汉字)</span>*/}
              </td>
              <td className={styles.tableInput}>
                {/* eslint-disable-next-line no-undef */}
                <input type="text" className={styles.input} value={account} size={16} onChange={event => onValueChange('account', event.target.value)} />
                <span className={styles.spanColor}>*</span>
              </td>
            </tr>
            <tr>
              <td className={styles.tableLable}>
                密码:<br />
                {/*<span className={styles.spanColor}>(身份证号后6位)</span>*/}
              </td>
              <td className={styles.tableInput}>
                <input className={styles.input} value={password} size={16} type="password" onChange={event => onValueChange('password', event.target.value)} />
                <span className={styles.spanColor}>*</span>
              </td>
            </tr>
            <tr>
              <td className={styles.tableSubmit} colSpan="2">
                <input type="button" value="登   录" className={styles.button} maxLength="16" size={20} onClick={onSubmit} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/index.js